"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTextCell = void 0;
const react_1 = __importDefault(require("react"));
const text_field_1 = require("../../../components/text-field/text-field");
function FilterTextCell({ disabled, value, onChange, }) {
    return (react_1.default.createElement(text_field_1.TextField
    //placeholder={!disabled ? 'zadejte text...' : ''}
    , { 
        //placeholder={!disabled ? 'zadejte text...' : ''}
        value: value, disabled: disabled, onChange: onChange }));
}
exports.FilterTextCell = FilterTextCell;
//# sourceMappingURL=filter-text-cell.js.map